import { render, staticRenderFns } from "./simpleKeyboard.vue?vue&type=template&id=26c2d7be&"
import script from "./simpleKeyboard.vue?vue&type=script&lang=js&"
export * from "./simpleKeyboard.vue?vue&type=script&lang=js&"
import style0 from "./simpleKeyboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports